import { container } from "tsyringe";
import ApiService from "@/app/infrastructures/services/ApiService";
import { POSLeaderboardApiRepository } from "@/app/infrastructures/repositories/api/POSLeaderboardApiRepository";
import { POSLeaderboardMapper } from "@/data/persistences/mappers/POSLeaderboardMapper";
import { POSLeaderboardEndpoint } from "@/app/infrastructures/endpoints/POSLeaderboardEndpoint";
import { POSLeaderboardPresenter } from "@/app/ui/presenters/POSLeaderboardPresenter";

export class POSLeaderboardComponent {
  public static init() {
    container.register<POSLeaderboardApiRepository>(
        POSLeaderboardApiRepository,
      {
        useFactory: d => {
          return new POSLeaderboardApiRepository(
            d.resolve(ApiService),
            d.resolve(POSLeaderboardMapper),
            d.resolve(POSLeaderboardEndpoint)
          );
        }
      }
    );
    container.register<POSLeaderboardMapper>(POSLeaderboardMapper, {
      useClass: POSLeaderboardMapper
    });
    container.register<POSLeaderboardPresenter>(
        POSLeaderboardPresenter,
      {
        useFactory: d => {
          return new POSLeaderboardPresenter(
            d.resolve(POSLeaderboardApiRepository)
          );
        }
      }
    );
  }
}
